export function nfmt(n: number): string {
  return new Intl.NumberFormat('ru-RU').format(Math.round(n));
}

export function plural(n: number, one: string, few: string, many: string): string {
  const m10 = n % 10, m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return one;
  if (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) return few;
  return many;
}

/** «2 дня 04:31» — компактно и без секунд, когда до события больше суток. */
export function untilText(target: string | Date | null | undefined, now = Date.now()): string {
  if (!target) return '—';
  const ms = new Date(target).getTime() - now;
  if (ms <= 0) return 'уже';
  const s = Math.floor(ms / 1000);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const pad = (x: number) => String(x).padStart(2, '0');
  if (d > 0) return `${d} ${plural(d, 'день', 'дня', 'дней')} ${pad(h)}:${pad(m)}`;
  return `${pad(h)}:${pad(m)}:${pad(sec)}`;
}

export const REASONS: Record<string, string> = {
  onboarding: 'Знакомство',
  streak_daily: 'Ежедневный вход',
  streak_week: 'Неделя без пропусков',
  task: 'Задание',
  task_revoked: 'Награда снята',
  wheel_spin: 'Прокрут колеса',
  wheel_prize: 'Приз с колеса',
  free_spin: 'Бесплатный прокрут',
  prize_ticket: 'Билет в розыгрыш',
  referral_l1: 'Друг активировался',
  referral_l2: 'Друг второго уровня',
  referral_passive: 'Процент с друга',
  course_block: 'Блок курса',
  course_completed: 'Курс пройден',
  shop_purchase: 'Покупка в магазине',
  season_close: 'Закрытие сезона',
  admin_adjust: 'Правка администратора',
};

export function reasonText(type: string): string {
  if (type.endsWith('_mint')) return `${REASONS[type.slice(0, -5)] ?? 'Начисление'} · кристаллы`;
  return REASONS[type] ?? type;
}
